import { render, staticRenderFns } from "./OrderFormBid.vue?vue&type=template&id=2ede3a47&scoped=true&"
import script from "./OrderFormBid.vue?vue&type=script&lang=js&"
export * from "./OrderFormBid.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormBid.vue?vue&type=style&index=0&id=2ede3a47&lang=sass&scoped=true&"
import style1 from "./OrderFormBid.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ede3a47",
  null
  
)

export default component.exports